import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5c58b312")

_pushScopeId("data-v-5c58b312")
const _hoisted_1 = { class: "flex flex-row w-full" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex items-center justify-center py-2 px-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Tambahan ")
const _hoisted_6 = { class: "flex flex-wrap flex-col ml-8 py-4 items-start justify-items-start" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "Baca Syarat dan ketentuan untuk informasi lebih lengkap", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock("div", null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
      return (_openBlock(), _createBlock(_component_Card, {
        key: index,
        class: "mb-4",
        customClass: "border-none",
        style: {
        'background-image': `url(${require(`@/app/ui/assets/images/progressive-commission/${
          _ctx.progress[index] ? 'background-active' : 'background-inactive'
        }.png`)})`,
        'background-size': '100% 100%',
        'background-repeat': 'no-repeat'
      }
      }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                (index < 4)
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: 
                require(`@/app/ui/assets/images/progressive-commission/${
                  _ctx.progress[index] ? 'money-active-1' : `money-inactive-2`
                }.png`)
              ,
                      class: "h-auto w-20",
                      alt: "status"
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock("img", {
                      key: 1,
                      src: 
                require(`@/app/ui/assets/images/progressive-commission/${
                  _ctx.progress[index] ? 'money-active-1' : `money-inactive-4`
                }.png`)
              ,
                      class: "h-auto w-20",
                      alt: "status"
                    }, null, 8, ["src"]))
              ]),
              _createVNode("div", {
                class: 
              `
              text-white text-2xl
              ${_ctx.progress[index] ? 'text-shadow-active' : 'text-shadow-inactive'}
              font-bold
              tracking-wider
              py-4
            `
            
              }, [
                _createVNode("p", null, [
                  _createTextVNode(_toDisplayString(_ctx.progress[index] ? "Mendapat" : "Dapatkan") + " ", 1),
                  _hoisted_4,
                  _hoisted_5
                ])
              ], 2),
              _createVNode("div", {
                class: 
              `
              text-white
              bonus
              ${_ctx.progress[index] ? 'text-shadow-active' : 'text-shadow-inactive'}
              font-bold
              tracking-wider
              py-2
              pl-4
            `
            
              }, [
                _createVNode("p", null, _toDisplayString(step.bonus) + "%", 1)
              ], 2),
              _createVNode("div", _hoisted_6, [
                _createVNode("div", {
                  class: 
                `
                text-white text-lg
                ${
                  _ctx.progress[index]
                    ? 'text-shadow-limit-active'
                    : 'text-shadow-limit-inactive'
                }
                font-bold
                tracking-wider
              `
              
                }, [
                  _createVNode("p", null, " Untuk minimal pendapatan bulanan " + _toDisplayString(_ctx.formatPrice(step.limit)), 1)
                ], 2),
                _createVNode("div", {
                  class: 
                `text-sm text-black-lp-300
                ${_ctx.progress[index] ? 'bg-white' : 'bg-gray-lp-1300'}
                py-1 px-2
                mt-2
                rounded-lg`
              
                }, [
                  _hoisted_7
                ], 2)
              ])
            ])
          ])
        ]),
        _: 2
      }, 1032, ["style"]))
    }), 128))
  ]))
})